import React from "react";
import { fmtCurrency, fmtNumber } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { TID } from "@/constants/tids";
import { TrendingUp, DollarSign, Target, Trophy } from "lucide-react";

function KpiCard({ label, value, sub, icon: Icon, testId }) {
  return (
    <Card data-testid={testId}>
      <CardContent className="pt-5">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm text-muted-foreground">{label}</p>
            <p className="text-2xl font-bold text-foreground mt-1">{value}</p>
            {sub && <p className="text-xs text-muted-foreground/70 mt-1">{sub}</p>}
          </div>
          <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-primary/10 text-primary">
            <Icon className="w-5 h-5" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default function DashboardKpis({ k }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <KpiCard
        testId={TID.kpiOpenPipeline}
        label="Open Pipeline"
        value={fmtCurrency(k.open_pipeline_value)}
        sub={`${fmtNumber(k.open_deals)} open deals`}
        icon={DollarSign}
      />
      <KpiCard
        testId={TID.kpiWeightedForecast}
        label="Weighted Forecast"
        value={fmtCurrency(k.weighted_forecast)}
        sub="probability-adjusted"
        icon={Target}
      />
      <KpiCard
        testId={TID.kpiWonValue}
        label="Won Revenue"
        value={fmtCurrency(k.won_value)}
        sub={`${fmtNumber(k.won_deals)} won · avg ${fmtCurrency(k.avg_deal_size)}`}
        icon={Trophy}
      />
      <KpiCard
        testId={TID.kpiWinRate}
        label="Win Rate"
        value={`${k.win_rate ?? 0}%`}
        sub={
          k.avg_sales_cycle_days != null
            ? `avg cycle ${k.avg_sales_cycle_days}d`
            : `${fmtNumber(k.lost_deals)} lost`
        }
        icon={TrendingUp}
      />
    </div>
  );
}
